import { useState, useEffect } from 'react';
import axios from 'axios';
import { flattenCategories } from '../utils/flattenCategories';

export const useCategories = () => {
  const [categories, setCategories] = useState([]);
  const [flattenedCategories, setFlattenedCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get('all-categories-tree');
        setCategories(res.data.categories_tree);
        setFlattenedCategories(flattenCategories(res.data.categories_tree));
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  return { categories, flattenedCategories, loading, error };
};
